/**
 * Barre di priorita v4 (N12, `Centro Ticket v4.dc.html` L262, L300, L803-L806):
 * quattro barrette 3×4/7/10/13 px accese fino al livello (bassa 1 … urgente 4).
 * Colore: bassa neutro, media ambra, alta e urgente rosso; alta e urgente si
 * distinguono dal NUMERO di barre, quindi restano leggibili anche senza colore
 * (CT-33). Nome accessibile «Priorità alta» sempre presente.
 *
 * `variant="hero"`: la stessa scala su fondo scuro della scheda ticket
 * (L341, L806: barrette 2×4/6/8/10 px, bianco su traccia); `decorative`
 * la nasconde ai lettori di schermo quando accanto c'e gia l'etichetta.
 */
import React from 'react';
import { PRIORITY_LABELS } from '../constants';

const LEVELS: Record<string, number> = { bassa: 1, media: 2, alta: 3, urgente: 4 };

/** Livello 0-4 della priorita (0 = sconosciuta: nessuna barra accesa). */
export const priorityLevel = (priority: string): number => LEVELS[priority] || 0;

export interface PriorityBarsProps {
  priority: string;
  withLabel?: boolean;
  /** `hero`: barrette sottili bianche per l'intestazione colorata della scheda. */
  variant?: 'default' | 'hero';
  /** Accanto c'e gia la priorita scritta: niente nome accessibile doppio. */
  decorative?: boolean;
}

const PriorityBars: React.FC<PriorityBarsProps> = ({
  priority,
  withLabel = false,
  variant = 'default',
  decorative = false,
}) => {
  const level = priorityLevel(priority);
  const label = PRIORITY_LABELS[priority] || priority;
  const a11y = decorative
    ? { 'aria-hidden': true as const }
    : { role: 'img' as const, 'aria-label': `Priorità ${label.toLowerCase()}` };
  const bars = (
    <span
      className={`s4-pb s4-pb--${priority}${variant === 'hero' ? ' s4-pb--hero' : ''}`}
      {...a11y}
      data-level={level}
    >
      {[1, 2, 3, 4].map((i) => (
        <i key={i} className={i <= level ? 's4-pb__on' : undefined} />
      ))}
    </span>
  );
  if (!withLabel) return bars;
  return (
    <span className="s4-pbl">
      {bars}
      <span className={`s4-pbl__txt s4-pbl__txt--${priority}`} aria-hidden="true">
        {label}
      </span>
    </span>
  );
};

export default PriorityBars;
